import { apiFetch, type IdResponse, type OperationResult } from "@/lib/apiClient";

export interface NamedItem {
  id: string;
  name: string;
  description: string | null;
}

function namedListApi(base: string) {
  return {
    list() {
      return apiFetch<NamedItem[]>(base);
    },
    create(name: string, description?: string | null) {
      return apiFetch<IdResponse>(base, {
        method: "POST",
        body: JSON.stringify({ name, description: description ?? null }),
      });
    },
    update(id: string, name: string, description?: string | null) {
      return apiFetch<OperationResult>(`${base}/${encodeURIComponent(id)}`, {
        method: "PUT",
        body: JSON.stringify({ name, description: description ?? null }),
      });
    },
    remove(id: string) {
      return apiFetch<void>(`${base}/${encodeURIComponent(id)}`, { method: "DELETE" });
    },
  };
}

export const branches = namedListApi("/branches");

export const groups = namedListApi("/groups");
